import { css, cva } from '@landr/styled-system/css';

export const samplesTable = css({
    tableLayout: 'fixed',
    width: 'full',
    maxWidth: 'full',
});

export const playButtonCell = css({
    justifyContent: 'center',
    width: '50px',
});

export const waveformCell = css({
    width: '80%',
    maxWidth: '255px',
    paddingInline: 'none',
    flex: 1,
    paddingRight: 'md',
});

export const nameCell = css({
    width: 'full',
    maxWidth: '380px',
    flex: 1,
    '& button': {
        maxWidth: 'full',
        justifyContent: 'flex-start',
    },
});

export const informationsCell = cva({
    base: {
        justifyContent: 'flex-start',
        flex: 1,
        paddingX: 'sm',
    },
    variants: {
        isLargeDesktop: {
            true: {
                width: 'xl',
            },
            false: {
                width: 'lg',
            },
        },
        isKey: {
            true: {
                width: 'xl',
            },
        },
    },
    defaultVariants: {
        isLargeDesktop: false,
        isKey: false,
    },
});

export const actionsGroupCellStyles = cva({
    base: {
        width: 'calc((36px * 5) + (8px * 4))',
        maxWidth: 'calc((36px * 5) + (8px * 4))',
        position: 'relative',
        paddingLeft: '40px',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
    },
    variants: {
        isLg: {
            true: {
                paddingLeft: 'xs',
            },
        },
        isMd: {
            true: {
                width: 'calc((36px * 3) + (8px * 2))',
                maxWidth: 'calc((36px * 3) + (8px * 2))',
            },
        },
        isSm: {
            true: {
                width: '60%',
                maxWidth: '60%',
                paddingLeft: 'none',
            },
        },
    },
});

export const responsiveGroupItem = css({
    mdDown: {
        display: 'none',
    },
});
